import React from "react";

export default function Card({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={`lg:p-5 p-3 rounded-xl border ${className}`}>
      {children}
    </div>
  );
}
